$(function () {
    // Scroll to abo from and select abo type
    $('[data-abo]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var aboType = $(this).data('abo'),
            $aboRadioBox = $('[data-abo-type=' + aboType + ']');

        if ($aboRadioBox.length) {
            $("body, html").animate({
                scrollTop: $aboRadioBox.offset().top - 300
            }, 600, function () {
                $aboRadioBox.trigger('click');
            });
        }
    });
});